import React from "react";
import "./form.scss";

const Textarea = ({ name, label, error, required, ...rest }) => {
  return (
    <div className={ error ? 'form-group has-error' : 'form-group'}>
      <div className="d-flex flex-column-reverse">
        <textarea {...rest} required={required} name={name} id={name} className="form-control" ></textarea>
        <label htmlFor={name}>{label}</label>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Textarea;
